import React from 'react';
import cx from 'classnames';

import type { IconButtonProps } from './IconButton.types';
import styles from './IconButton.module.scss';
import Button from '../Button';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';

const IconButton = (props: IconButtonProps) => {
  const {
    className,
    appearance = 'Default',
    size = 'Medium',
    type = 'Filled',
    style = 'Primary',
    icon,
    ...otherProps
  } = props;
  
  const variantProps = useBuildVariantProps(
    'icon-button',
    { appearance, size, style, type },
  );

  return (
    <Button
      className={cx(
        styles.iconButton,
        className,
      )}
      appearance={appearance}
      size={size}
      style={style}
      type={type}
      leadingIcon={icon}
      {...variantProps}
      {...otherProps}
    >
    </Button>
  );
};

export default IconButton;